import React from 'react'
import { ConfigProvider, theme } from 'antd'
import type { ThemeConfig } from 'antd'
import colors from '@sportninja/common/constants/appColors'

const THEME: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: colors.DEFAULT_FLAIR,
    colorPrimaryHover: colors.PRIMARY_LIGHT,
    colorBgContainer: colors.HEADER,
    colorBorder: colors.SOFT_STEEL,
    colorLink: colors.DEFAULT_FLAIR,
    borderRadius: 4,
    borderRadiusLG: 8,
    borderRadiusSM: 4,
    borderRadiusXS: 2,
  },
  components: {
    Button: {
      primaryShadow: 'none',
      boxShadow: 'none',
      boxShadowSecondary: 'none',
      boxShadowTertiary: 'none',
      defaultShadow: 'none',
      controlHeight: 40,
      defaultBg: 'transparent',
      defaultBorderColor: colors.DEFAULT_FLAIR,
    },
    Input: {
      controlHeight: 40,
      colorBgContainer: 'transparent',
      colorBgContainerDisabled: 'transparent',
      colorTextDisabled: colors.ATTENDANCE_GRAY,
    },
    Select: {
      controlHeight: 40,
      colorBgContainer: 'transparent',
      colorBgContainerDisabled: 'transparent',
      colorTextDisabled: colors.ATTENDANCE_GRAY,
    }
  }
}

interface Props {
  children: React.ReactNode | JSX.Element
}

export const ThemeProvider = ({ children }: Props) => (
  <ConfigProvider theme={THEME}>{children}</ConfigProvider>
)
